import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  Routes,
  Route,
  unstable_HistoryRouter as HistoryRouter,
} from "react-router-dom";

import { createBrowserHistory } from "history";


import { BASEURL } from "../config";
import axios from "axios";
import { HolidayVillage } from "@mui/icons-material";
import Home from "../pages/home/home";
import VoiceBot from "../components/chatBot/voiceBot";

const history = createBrowserHistory();
// const token = JSON.parse(localStorage.getItem("token"));

let publicIP;
const Router = () => {
  return (
    <>
      <HistoryRouter history={history}>
        
          <Routes>
            <Route path="/" element={<Home/>} />
              <Route path="/voice" element={<VoiceBot source="talha" />} />
          </Routes>
       
      </HistoryRouter>
    </>
  );
};
export default Router;
